import { render, staticRenderFns } from "./template1.vue?vue&type=template&id=13ee4440&scoped=true"
import script from "./template1.vue?vue&type=script&lang=js"
export * from "./template1.vue?vue&type=script&lang=js"
import style0 from "./template1.vue?vue&type=style&index=0&id=13ee4440&prod&scoped=true&lang=scss"
import style1 from "./template1.vue?vue&type=style&index=1&id=13ee4440&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ee4440",
  null
  
)

export default component.exports